import styled, { DefaultTheme } from 'styled-components';
import { boxShadows, colorTransitionDuration, ThemeColor } from 'styles';

export type ButtonColor = ThemeColor | 'transparent';

type ButtonProps = {
  color: ThemeColor;
  $backgroundColor: ButtonColor;
  $marginRight?: boolean;
};

function renderColor(theme: DefaultTheme, color: ThemeColor) {
  return theme.colors[color];
}

function renderBackgroundColor(
  theme: DefaultTheme,
  $backgroundColor: ButtonColor
) {
  if ($backgroundColor === 'transparent') {
    return 'transparent';
  }
  return theme.colors[$backgroundColor];
}

function renderHoverColor(theme: DefaultTheme, $backgroundColor: ButtonColor) {
  if ($backgroundColor === 'primaryDark') {
    return theme.colors.primary;
  }

  return 'transparent';
}

export const StyledButton = styled.button<ButtonProps>`
  margin: 0;
  margin-right: ${({ $marginRight }) => ($marginRight ? '16px' : '0')};
  background-color: ${({ theme, $backgroundColor }) =>
    renderBackgroundColor(theme, $backgroundColor)};
  color: ${({ theme, color }) => renderColor(theme, color)};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  border: 1px solid
    ${({ theme, $backgroundColor }) =>
      renderBackgroundColor(theme, $backgroundColor)};
  transition: background-color ${colorTransitionDuration};
  border-radius: 16px;
  font-size: 16px;
  line-height: 20px;
  padding: ${({ $backgroundColor }) =>
   $backgroundColor === 'transparent' ? '0px 24px 0px 0px' : '14px 24px'};
  box-shadow: ${({ $backgroundColor }) =>
    $backgroundColor === 'transparent' ? 'none' : boxShadows.normal};
  text-transform: ${({ $backgroundColor }) =>
    $backgroundColor === 'transparent' ? 'initial' : 'uppercase'};
  font-weight: bold;
  cursor: pointer;

  :hover {
    background-color: ${({ theme, $backgroundColor }) =>
      renderHoverColor(theme, $backgroundColor)};
  }

  :active {
    background-color: ${({ theme, $backgroundColor }) =>
      renderBackgroundColor(theme, $backgroundColor)};
  }
`;
